import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { CasheringService } from '../../../../domain/services/cashering/cashering.service';
import { DialogService } from '../../../../domain/services/dialog/dialog.service';
import { ReturnAttachmentModel } from '../../../../domain/models/return.model';

@Component({
  selector: 'app-return-attachments',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatTableModule
  ],
  templateUrl: './return-attachments.component.html',
  styleUrls: ['./return-attachments.component.css']
})
export class ReturnAttachmentsComponent implements OnInit {
  @Input() returnId!: number;
  @Input() attachments: ReturnAttachmentModel[] = [];

  displayedColumns: string[] = ['fileName', 'fileSize', 'uploadedDate', 'uploadedBy', 'actions'];

  constructor(private casheringService: CasheringService, private dialogService: DialogService) {}

  ngOnInit(): void {
    this.loadAttachments();
  }

  loadAttachments(): void {
    this.casheringService.getAttachments(this.returnId).subscribe(
      attachments => {
        this.attachments = attachments;
      },
      (error: any) => {
        console.error('Error loading attachments:', error);
      }
    );
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      this.uploadFile(file);
    }
  }

  uploadFile(file: File): void {
    this.casheringService.uploadAttachment(this.returnId, file).subscribe(
      () => {
        this.loadAttachments();
      },
      (error: any) => {
        console.error('Error uploading file:', error);
      }
    );
  }

  downloadAttachment(attachment: ReturnAttachmentModel): void {
    this.casheringService.downloadAttachment(this.returnId, attachment.id).subscribe(
      (blob: Blob) => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = attachment.fileName;
        link.click();
        window.URL.revokeObjectURL(url);
      },
      (error: any) => {
        console.error('Error downloading file:', error);
      }
    );
  }

  deleteAttachment(attachmentId: number): void {
    this.dialogService.openDeletedDialog(
      'Delete Attachment',
      'Are you sure you want to delete this attachment? This action cannot be undone.',
      (confirmed: boolean) => {
        if (confirmed) {
          this.casheringService.deleteAttachment(this.returnId, attachmentId).subscribe(
            () => {
              this.loadAttachments();
            },
            (error: any) => {
              console.error('Error deleting attachment:', error);
            }
          );
        }
      }
    );
  }

  formatFileSize(bytes: number): string {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i];
  }
}
